import React, { useRef, useCallback, useState, memo, useEffect, Component } from 'react';
import {getDuration} from './getDuration.js';
import {useXVisible} from './useXVisible.js';
import {getVisualization} from './getVisualization.js';
import { connect } from "react-redux";
import Colors from 'components/Colors.js';
import {getBarWidth} from './getBarWidth.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {
    PATTERN_SWITCH,
    SEQUENCE_ROLL,
    RESOLUTION_CHANGE} from 'session/constants.js';

const rollSubId = 1000000;

const colors = new Colors();

const PatternComponent = memo((props) => {
    const ref = useRef(ref);
    const [showVisuals, setShowVisuals] = useState(true);

    useXVisible({
        horizontalScroll: props.arrangementContainer,
        ref,
        isSelected: props.isSelected
    });

    /*
    useEffect(() => {
        onScroll();
    }, []);

    useEffect(() => {
        if (!props.arrangementContainer) {
            return undefined;
        }
        props.arrangementContainer.current.addEventListener(
            'scroll', onScroll);

        return () => props.arrangementContainer.current ?
            props.arrangementContainer.current.removeEventListener(
            'scroll', onScroll) : undefined;
    }, [setShowVisuals, props.i, props.arrangementContainer]);

    const onScroll = useCallback((e) => {
        if (!props.arrangementContainer) {
            return;
        }
        let scrollLeft = props.arrangementContainer.current.scrollLeft;
        let rect = ref.current.getBoundingClientRect();
        let elemLeft = rect.left - 140;
        let width = props.arrangementContainer.current.clientWidth;
        
        let isVisible = (elemLeft >= 0) && (elemLeft <= width + 10 );
        setShowVisuals(isVisible);
    }, [setShowVisuals, props.i, props.arrangementContainer]);
    */
    
    const onRightMouseDown = useCallback((e) => {
        if (props.type === SEQUENCE_ROLL &&
            !props.event.value) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        props.onRightMouseDown();
    }, [props.type, props.event, props.onRightMouseDown]);

    const onLeftMouseDown = useCallback((e) => {
        if (props.type === SEQUENCE_ROLL &&
            !props.event.value) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        props.onLeftMouseDown();
    }, [props.type, props.event, props.onLeftMouseDown]);

    const onSelect = useCallback((e) => {
        if (props.type === SEQUENCE_ROLL &&
            !props.event.value) {
            return;
        }
        e.stopPropagation();
        props.onSelect(e);
    }, [props.type, props.event]);
    
    let text = '';
    if (props.type === PATTERN_SWITCH) {
        text = props.value + 1;
    } else if (props.type === SEQUENCE_ROLL) {
        text = props.value + ' ';
    }

    const getAdditionalStyling = useCallback((style) => {
        if (props.type === SEQUENCE_ROLL) {
            if (!props.event.value) {
                // not rolling so make it invisible
                style.opacity = 0.001;
            }
        }
        return style;
    }, [props.type, props.event]);

    let hasEdges = false;
    if (props.type === SEQUENCE_ROLL &&
        !props.event.value) {
        hasEdges = false;
    } else {
        hasEdges = true;
    }

    let topStyle = {};
    let duration = props.duration === undefined ? 64 : props.duration;
    let color;
    if (props.isRoll) {
        let resolution = props.event.resolution;
        if (resolution === undefined) {
            color = colors.getColor(13);
        } else {
            color = colors.getColor(resolution.resolution);
        }
    } else {
        let eventKey = props.subSequence.id.slice ?
            props.subSequence.id.slice(0, 10) : 's' + props.subSequence.id;
        color = colors.getColorForHash(eventKey);
        if (!isNaN(props.value)) {
            topStyle.backgroundSize = (props.value + 1)*4 + 'px 50px';
        }
    }
    let fullStyle = {
    };
    topStyle = {
        ... topStyle,
        width: getBarWidth(duration, props.resolution, props.xScale) - 2,
        backgroundColor: colors.saturate(color, 3)
    };

    fullStyle = getAdditionalStyling(fullStyle);

    let className = props.isSelected ?
        "pattern selected" : "pattern";
    
    if (props.isLast) {
        className += ' last';
    }

    fullStyle['width'] = getBarWidth(duration, props.resolution, props.xScale);

    let restStyle = {
        width: topStyle.width,
        maxWidth: props.maxWidth || topStyle.width,
    };

    if (props.isSelected && color) {
        fullStyle['border'] = 'solid 1px ' + colors.brighten(color, 1.5);
        restStyle['backgroundColor'] = colors.brighten(color, 0.4);
    }

    if (props.smallPattern) {
        className += ' small-pattern';
    }

    if (duration === 0) {
        return [];
    }

    return (
        <div
          ref={ref}
          className={className}
          onMouseUp={props.onMouseUp}
          style={fullStyle}
        >
          <div
            style={topStyle} 
            onMouseDown={onSelect}
            className="pattern-top">
            <ConditionedComponent condition={hasEdges}>
              <div
                onMouseDown={onLeftMouseDown}
                onMouseUp={props.onMouseUp}
                className="left-edge"/>
            </ConditionedComponent>
            <div className="pattern-number">
              {text}
            </div>
            <ConditionedComponent condition={hasEdges}>
              <div
                onMouseDown={onRightMouseDown}
                onMouseUp={props.onMouseUp}
                className="right-edge"/>
            </ConditionedComponent>
          </div>
          {!props.smallPattern ? 
           <div
             style={restStyle} className="pattern-rest">
             {showVisuals ? getVisualization(
                 props.event, props.subSequence, duration, 
                 getBarWidth(1, props.resolution, props.xScale)) : ''}
             <div className="center"/>
           </div>
           : ''}
        </div>
    );
});

const mapStateToProps = (state, props) => {
    let selectedEvents = state.arrangement.selectedEvents;
    let isSelected = selectedEvents === undefined ?
        false :
        selectedEvents[props.event.id] !== undefined;
    return {
        isSelected: isSelected,
        duration: props.event.duration,
        value: props.event.value,
        xScale: state.arrangement.xScale,
    };
};

export default connect(mapStateToProps, null)(PatternComponent);
